const baseURL: string = "https://elministry-api-ehgzcmg6bxeyd7dc.centralus-01.azurewebsites.net/api/";
const ticketBaseURL: string = "https://jvcrm-api.azurewebsites.net/api/";
const appName: string = "ELM";
const appId: string = "8"

export default baseURL;
export { ticketBaseURL, appName, appId };